import React, { Component } from "react"
import { Switch } from "react-router"
import { Route, Redirect } from "react-router-dom"
import { SemiPrivateRouteWithData } from "../../shared/routeHandlers"
import TopNav from "../../components/TopNav"
import Account from "../Account"
import { Helmet } from "react-helmet"

import "./accountLanding.scss"

class AccountLanding extends Component {
  constructor(props) {
    super(props)
  }

  render = () => {
    const navItems = [
      {
        to: "/account",
        title: "Your Account",
      },
    ]

    const routes = [
      {
        path: "/account",
        exact: true,
        render: (props) => <Account {...this.props} {...props} />,
      },
    ]

    return (
      <div className="account-main-container">
        <Helmet>
          <title>Account | ETR</title>
        </Helmet>
        <TopNav
          navItems={navItems}
          isActive={({ to }) =>
            to === "/account/order-history"
              ? this.props.location.pathname
                  .toLowerCase()
                  .indexOf(to.toLowerCase()) > -1
              : to.toLowerCase() === this.props.location.pathname.toLowerCase()
          }
          {...this.props}
        />
        <Switch>
          {routes.map((route, i) => (
            <SemiPrivateRouteWithData key={i} {...route} />
          ))}
          <Route render={(props) => <Redirect to="/not-found" />} />
        </Switch>
      </div>
    )
  }
}

export default AccountLanding
